import { WhatsAppLocaleContent } from 'modules/templateEditor/common/types';
import { BADGE_VARIANTS } from 'ui/badge';
import { WarningFill16 } from 'ui/icons';
import { HelpTooltip } from 'ui/tooltip';
import { WhatsAppLowQualityBadge } from './WhatsAppLowQualityBadge';
import { InvertedWarningBadge, Wrapper } from './styles';

const multipleIssuesText = {
  badge: 'Issues with locales',
  tooltip: 'Multiple locales in this template have issues.',
};

type WhatsAppNegativeTemplateBadgeProps = {
  lowQualityLocales: WhatsAppLocaleContent[];
  totalLocales: number;
};

export const MULTIPLE_ISSUES_BADGE_TEST_ID = 'multiple-issues-badge';

export const WhatsAppNegativeTemplateBadge = ({
  lowQualityLocales,
  totalLocales,
}: WhatsAppNegativeTemplateBadgeProps) => {
  // multiple issues
  if (lowQualityLocales.length > 1) {
    return (
      <InvertedWarningBadge
        data-test={MULTIPLE_ISSUES_BADGE_TEST_ID}
        icon={<WarningFill16 />}
        variant={BADGE_VARIANTS.INVERTED}
      >
        <Wrapper>
          <span>{multipleIssuesText.badge}</span>
          <HelpTooltip
            automaticallyAvoidCollisions
            iconProps={{ height: 16, width: 16, isColorInherited: true }}
            tooltipContent={multipleIssuesText.tooltip}
          />
        </Wrapper>
      </InvertedWarningBadge>
    );
  }

  return (
    <WhatsAppLowQualityBadge numLocales={totalLocales} lowQualityLocales={lowQualityLocales} />
  );
};
